// extracted by mini-css-extract-plugin
module.exports = {"zIndexToolTip":"13380000","wrapper":"styles_wrapper__19Cil","fileEntry":"styles_fileEntry__Df5ko","downloadCircleWrapper":"styles_downloadCircleWrapper__2Tu-D"};